import { render, staticRenderFns } from "./textEnd.vue?vue&type=template&id=5fb50432&"
import script from "./textEnd.vue?vue&type=script&lang=ts&"
export * from "./textEnd.vue?vue&type=script&lang=ts&"
import style0 from "./textEnd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports